module.exports = __webpack_public_path__ + "img/gzh_code.c015ddf1.png";